// This icon file is generated automatically.
var PArrowupOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.56 6.52L6.38.55a.5.5 0 00-.76 0L.44 6.52c-.07.08-.02.21.1.21H1.8c.07 0 .14-.03.19-.09L5.4 2.7v8.8c0 .07.05.13.12.13h.94c.07 0 .12-.06.12-.13V2.7l3.42 3.94c.05.06.12.09.2.09h1.26c.1 0 .16-.13.1-.2z", "fill-rule": "nonzero" } }] }, "name": "p-arrowup", "theme": "outlined" };
export default PArrowupOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PArrowUpOutlined.js
// module id = 3214
// module chunks = 0